"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BestfitProgrammeClient = void 0;
const model_client_1 = require("../../model-client");
class BestfitProgrammeClient extends model_client_1.ModelClient {
    getModelName() {
        return 'bestfit-programme';
    }
    getVersion() {
        return 'v1';
    }
    isPublic() {
        return false;
    }
}
exports.BestfitProgrammeClient = BestfitProgrammeClient;
//# sourceMappingURL=bestfit-programme-client.js.map